export default "###### Carma's details:\n\n<strong> Phone number: </strong> 0400 000 000 </br>\n<strong> Email address: </strong> hello@carma.com\n";